import { CSSProperties } from 'react';
import { EtapaCadastroProps } from '../../..';
import { ContainerEtapa } from '../../../styles';

import * as S from './styles';
import { Controller, UseFormWatch } from 'react-hook-form';
import {
  IndicadorValidacaoSenha,
  TextFieldCadastroConfirmarSenha,
  TextFieldCadastroSenha,
} from '@/components/organisms/TextFieldCadastroSenha';
import Checkbox from '@/components/molecules/Checkbox';
import { TextFieldSize } from '@/components/molecules/TextField';
import TextoTermosChippu from '@/components/molecules/TextoTermosChippu';

type EtapaSenhaETermosProps = EtapaCadastroProps & {
  style?: CSSProperties;
  usuarioAceitouOsTermos: boolean;
  aceitarTermos: () => void;
  inputSize?: TextFieldSize;
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  watchValue: UseFormWatch<T>;
};

export default function EtapaSenhaETermos(props: EtapaSenhaETermosProps) {
  const {
    style,
    $control,
    $errors,
    usuarioAceitouOsTermos,
    aceitarTermos,
    inputSize = 1,
    watchValue,
  } = props;

  return (
    <ContainerEtapa style={style}>
      <Controller
        name="senha"
        control={$control}
        render={({ field }) => (
          <TextFieldCadastroSenha
            $errors={$errors}
            $field={field}
            inputSize={inputSize}
          />
        )}
      />
      <Controller
        name="confirmacaoSenha"
        control={$control}
        render={({ field }) => (
          <TextFieldCadastroConfirmarSenha
            $errors={$errors}
            $field={field}
            inputSize={inputSize}
          />
        )}
      />
      <IndicadorValidacaoSenha valorCampoSenha={watchValue('senha')} />
      <S.CheckboxGroup>
        <S.ButtonTermos type="button" onClick={aceitarTermos}>
          <Checkbox
            $size={1}
            $highContrast={false}
            $status={usuarioAceitouOsTermos ? 'checked' : 'unchecked'}
            $variant="classic"
          />
        </S.ButtonTermos>
        <TextoTermosChippu />
      </S.CheckboxGroup>
    </ContainerEtapa>
  );
}
